import { Controller } from "@hotwired/stimulus"

// Toggles between the two customer-selection modes on the PO review
// screen: "Use existing customer" (with a searchable dropdown) vs
// "Create new customer" (with name + email + phone + address inputs).
//
// Important behavior: we DISABLE the inactive panel's inputs so they
// don't get submitted. That keeps the server-side resolver simple — it
// just checks customer_id first, then new_customer[:name]. Without the
// disable, switching to "new" would still submit the pre-selected
// customer_id from the dropdown and the order would silently use the
// wrong customer.
//
// HTML5 `required` is also toggled per mode so the browser's native
// validation aligns with what the controller is going to enforce.
export default class extends Controller {
    static targets = [
        "existingPanel", "existingSelect",
        "newPanel",      "newName",
        "existingRadio", "newRadio"
    ]

    connect() {
        this.refresh()
    }

    modeChanged() {
        this.refresh()
    }

    refresh() {
        const mode = this.currentMode()

        if (this.hasExistingPanelTarget) {
            this.existingPanelTarget.style.display = mode === "existing" ? "block" : "none"
            this.toggleInputs(this.existingPanelTarget, mode !== "existing")
        }
        if (this.hasNewPanelTarget) {
            this.newPanelTarget.style.display = mode === "new" ? "block" : "none"
            this.toggleInputs(this.newPanelTarget, mode !== "new")
        }

        // Mode-aware HTML5 required so the browser blocks submit until
        // the active mode's primary field is filled in.
        if (this.hasNewNameTarget) {
            this.newNameTarget.required = mode === "new"
        }
        if (this.hasExistingSelectTarget) {
            this.existingSelectTarget.required = mode === "existing"
        }
    }

    currentMode() {
        if (this.hasNewRadioTarget && this.newRadioTarget.checked) return "new"
        return "existing"
    }

    // Disables (or re-enables) every form input inside a panel. Disabled
    // inputs aren't submitted with the form, so the server only sees the
    // active mode's data.
    toggleInputs(panel, disabled) {
        panel.querySelectorAll("input, select, textarea").forEach((el) => {
            el.disabled = disabled
        })
    }
}
